import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import ExpressRejectionList from '../entities/express-rejection-list'
import appconst from '@/lib/appconst';


interface ExpressRejectionState extends ListState<ExpressRejectionList> {
    ExpressRejectionInfo: ExpressRejectionList,
}

class BackLogisticsMutations extends ListMutations<ExpressRejectionList>{

}
class ExpressRejection extends ListModule<ExpressRejectionState, any, ExpressRejectionList>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<ExpressRejectionList>(),
        loading: false,
        logisticsInfo: ExpressRejectionList,


    }
    actions = {
        async getAll(context: ActionContext<ExpressRejectionState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/ExpressRejection/GetExpressRejectionList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<ExpressRejectionList>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        async editRevoked(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/ExpressRejection/EditRevoked', payload.data);
        },
        async createRejection(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/ExpressRejection/CreateRejectionInfo', payload.data);
        },
        async createReturn(state: any, payload: any) {
            let rep = await Ajax.post('/api/services/app/ExpressRejection/CreateReturnInfo', payload.data);
        }


  
    };
    mutations = {
        setCurrentPage(state: ExpressRejectionState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: ExpressRejectionState, pagesize: number) {
            state.pageSize = pagesize;
        },
    };
}





const expressrejectioninfo = new ExpressRejection();
export default expressrejectioninfo;